module.exports = __webpack_public_path__ + "media/images/defaultrubrics-c52bbf2d.png";